import {Injectable} from '@angular/core';
import {LoadingController} from "@ionic/angular";

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loading: any;

  constructor(
    private readonly loadingCtrl: LoadingController
  ) {}

  async show() {
    this.loading = await this.loadingCtrl.create({
      message: 'Loading...',
      spinner: 'circles',
      id: 'loading'
    });
    this.loading.present().then();
  }

  async hide() {
    await this.loading.dismiss().then();
  }
}
